/**
 * MRO Typewriter Effect
 * Cycles through words with a typing animation effect
 */
class MROTypewriter {
  constructor(element) {
    this.element = element;
    this.words = JSON.parse(element.dataset.words || '["genetics", "lab results", "lifestyle"]');
    this.typeSpeed = parseInt(element.dataset.typeSpeed || '130');
    this.deleteSpeed = parseInt(element.dataset.deleteSpeed || '50');
    this.pauseTime = parseInt(element.dataset.pauseTime || '2000');
    
    this.currentWordIndex = 0;
    this.currentCharIndex = 0;
    this.cursorVisible = true;
    this.typewriterInterval = null;
    this.cursorInterval = null;
    
    this.init();
  }
  
  init() {
    console.log('MRO Typewriter initialized with words:', this.words);
    this.startCursorBlink();
    // Start typing after a 2.5 second delay (500ms for page load + 2000ms for cursor-only display)
    setTimeout(() => {
      console.log('Starting typewriter animation');
      this.startTypewriter();
    }, 2500);
  }
  
  destroy() {
    if (this.typewriterInterval) {
      clearInterval(this.typewriterInterval);
    }
    if (this.cursorInterval) {
      clearInterval(this.cursorInterval);
    }
  }
  
  startCursorBlink() {
    this.cursorInterval = setInterval(() => {
      this.cursorVisible = !this.cursorVisible;
      this.updateDisplay();
    }, 500); // Blink every 500ms
  }
  
  updateDisplay() {
    const currentWord = this.words[this.currentWordIndex];
    const text = currentWord.substring(0, this.currentCharIndex);
    this.element.textContent = text;
    
    if (this.cursorVisible) {
      this.element.classList.add('cursor-blink');
    } else {
      this.element.classList.remove('cursor-blink');
    }
  }
  
  startTypewriter() {
    this.typewriterInterval = setInterval(() => {
      this.typeNextChar();
    }, this.typeSpeed);
  }
  
  typeNextChar() {
    const currentWord = this.words[this.currentWordIndex];
    
    // Typing characters
    this.currentCharIndex++;
    this.updateDisplay();
    
    // Handle word completion and transitions
    if (this.currentCharIndex === currentWord.length) {
      // Finished typing current word, pause then move to next word
      clearInterval(this.typewriterInterval);
      setTimeout(() => {
        this.currentWordIndex = (this.currentWordIndex + 1) % this.words.length;
        this.currentCharIndex = 0;
        this.startTypewriter();
      }, this.pauseTime);
    }
  }
}

// Initialize all typewriter elements
function initTypewriters() {
  const typewriterElements = document.querySelectorAll('[data-mro-typewriter]');
  console.log('Found', typewriterElements.length, 'typewriter elements');
  typewriterElements.forEach(element => {
    // Store instance on element to allow cleanup
    if (!element.typewriterInstance) {
      element.typewriterInstance = new MROTypewriter(element);
    }
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTypewriters);
} else {
  initTypewriters();
}

// Support for Shopify theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const typewriterElements = event.target.querySelectorAll('[data-mro-typewriter]');
    typewriterElements.forEach(element => {
      // Cleanup old instance
      if (element.typewriterInstance) {
        element.typewriterInstance.destroy();
      }
      // Create new instance
      element.typewriterInstance = new MROTypewriter(element);
    });
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const typewriterElements = event.target.querySelectorAll('[data-mro-typewriter]');
    typewriterElements.forEach(element => {
      if (element.typewriterInstance) {
        element.typewriterInstance.destroy();
        element.typewriterInstance = null;
      }
    });
  });
}

